import SignUp from './container'

export default SignUp
